import { RootState } from "store/store";

export const selectProviders = (state: RootState) => state.providers.providers;

export const selectProvidersCards = (state: RootState) =>
  state.providers.providersCards;

export const selectProvidersCollection = (state: RootState) =>
  state.providers.providersCollection;
